import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { InvoiceDataRepository } from "../domain/InvoiceDataRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { InvoiceRetrieveData } from "../domain/InvoiceRetrieveData";
import { Invoice } from "~/context/Invoices/domain/Invoice";
import { InvoiceSumByYearMonthType } from "~/context/InvoicesData/domain/InvoiceSumByYearMonthType";
import { InvoiceSumIncomeOutcomeByYearMonthType } from "../domain/InvoiceSumIncomeOutcomeByYearMonthType";
import { InvoiceSumCompraVentaByYearMonthType } from "../domain/InvoiceSumCompraVentaByYearMonthType";
import { InvoiceSumPendingByYear } from "../domain/InvoiceSumPendingByYear";
import { InvoiceIncomeOutcomeSumFutureByRange } from "../domain/InvoiceIncomeOutcomeSumFutureByRange";

export function createApiInvoiceDataRepository(): InvoiceDataRepository {
  return new ApiInvoiceDataRepository();
}

export class ApiInvoiceDataRepository extends APIRepository implements InvoiceDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getInvoicesRetrievedByCompanyAndDate(companyUid: string, dateBegin: string, dateEnd: string): Promise<InvoiceRetrieveData[]> {
    console.log("getInvoicesRetrievedByCompanyAndDate companyUid: " + companyUid);
    //transforma el dateBegin en un formato yyyymmdd. El dateBegin viene como un string de date ISO
    //const dateBeginFormatted = new Date(dateBegin).toISOString().split("T")[0].replace(/-/g, "");
    console.log("dateBegin: " + JSON.stringify(dateBegin));
    console.log("dateEnd: " + JSON.stringify(dateEnd));

    const dateBeginFormatted = formatDate(dateBegin);
    const dateEndFormatted = formatDate(dateEnd);

    //console.log("dateBeginFormatted:" + dateBeginFormatted);
    //console.log("dateEndFormatted:" + dateEndFormatted);


    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceRetrieveData[]>("/api/invoicesdata/loaded/company/" + companyUid.toString() + "/begin/" + dateBeginFormatted + "/end/" + dateEndFormatted);
    }

  }

  getLastNInvoicesIncomeByCompany(companyUid: string, quantity:number): Promise<Invoice[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Invoice[]>("/api/invoicesdata/incomes/last/company/" + companyUid.toString() + "/quantity/" +quantity);
    }
  }

  getLastNInvoicesOutcomeByCompany(companyUid: string, quantity:number): Promise<Invoice[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Invoice[]>("/api/invoicesdata/outcomes/last/company/" + companyUid.toString() + "/quantity/" +quantity);
    }
  }

  getInvoicesYearMonthTypeByCompany(companyUid: string): Promise<InvoiceSumByYearMonthType[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumByYearMonthType[]>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeByYearMonthType" );
    }
  }

  getIncomeOutcomeInvoicesYearMonthTypeByCompany(companyUid: string): Promise<InvoiceSumIncomeOutcomeByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumIncomeOutcomeByYearMonthType>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeIncomeOutcomeByYearMonthType" );
    }
  }

  getCompraVentaInvoicesYearMonthTypeByCompany(companyUid: string): Promise<InvoiceSumCompraVentaByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumCompraVentaByYearMonthType>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeCompraVentaByYearMonthType" );
    }
  }

  listSumPendingIncomeInvoicesYear(companyUid: string): Promise<InvoiceSumPendingByYear[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumPendingByYear[]>("/api/invoicesdata/company/" + companyUid.toString() + "/resumePendingIncomeInvoicePerYear" );
    }
  }

  listSumOverdueOutcomeInvoicesYear(companyUid: string): Promise<InvoiceSumPendingByYear[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("(listSumOverdueOutomeInvoicesYear) CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumPendingByYear[]>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeOverdueOutcomeInvoicePerYear" );
    }
  }


  listSumFutureOutcomeInvoicesRange(companyUid: string): Promise<InvoiceIncomeOutcomeSumFutureByRange[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceIncomeOutcomeSumFutureByRange[]>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeFutureOutcomeInvoicePerRange" );
    }
  }

  listSumFutureIncomeInvoicesRange(companyUid: string): Promise<InvoiceIncomeOutcomeSumFutureByRange[]>{
  if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceIncomeOutcomeSumFutureByRange[]>("/api/invoicesdata/company/" + companyUid.toString() + "/resumeFutureIncomeInvoicePerRange" );
    }
  }


}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Meses van de 0 a 11
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}${month}${day}`;
}
